import { z } from "zod";

import { formSchema } from "@/features/forms/models";
import type { Form } from "@/features/forms/models";
import type { Product } from "@/features/products/models";
import { parseResponseData, privateAPI } from "@/shared/lib";
import type { RefillType } from "@/shared/models";

export const getIntake = async (productId: Product["id"]) => {
  const response = await privateAPI.get("/forms", {
    params: {
      isRefill: false,
      productId,
    },
  });

  return parseResponseData(response, formSchema);
};

type FieldValues = Record<string, string | string[]>;

interface SubmitField {
  value: string | string[] | undefined;
  fieldId: string;
}

const parseFormFields = (params: FieldValues): SubmitField[] => {
  return Object.keys(params).map((key) => ({
    value: Array.isArray(params[key]) ? params[key].join("\n") : params[key],
    fieldId: key,
  }));
};

interface submitIntakeParams {
  userPreference: RefillType;
  formId: Form["formId"];
  productId: Product["id"];
  answers: Record<string, string | string[]>;
}

const intakeResponseSchema = z.object({
  needsSync: z.boolean(),
  isDisqualified: z.boolean(),
});

export const submitIntake = async ({
  answers,
  ...params
}: submitIntakeParams) => {
  const response = await privateAPI.post(
    "/forms",
    {
      ...params,
      answers: parseFormFields(answers),
    },
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  return parseResponseData(response, intakeResponseSchema);
};
